import sortBy from 'lodash/sortBy';

import { setAttachmentFolder, setFolderParent } from './api';
import { rootFolder } from './config';

export function replace(collection, changedItem) {
  return collection.map(item => item.id === changedItem.id ? changedItem : item);
}

export function sort(collection, sortOrder) {
  let key = sortOrder.key;

  if (key === 'name' && collection[0]?.displayName) {
    key = 'displayName';
  } else if (key === 'lastModified') {
    key = 'createdAt';
  }

  const sorted = sortBy(collection, key);
  if (sortOrder.reverse) {
    sorted.reverse();
  }

  return sorted;
}

export function handleDrag(attachments, folders, dragIndex, dropIndex) {
  const folder = folders[dragIndex];
  const attachment = attachments[dragIndex - folders.length];
  const target = folders[dropIndex];

  if (target) {
    if (folder && folder.id !== target.id) {
      return { folder: setFolderParent(folder, target) };
    } else if (attachment) {
      return { attachment: setAttachmentFolder(attachment, target) };
    }
  }

  return {};
}

export function findParentFolder(folders, folderId) {
  const target = folders.find(folder => folder.id === folderId);
  return folders.find(folder => folder.id === target.parentFolderId) || rootFolder;
}
